import { colorConstants } from 'config/colorConstants';
import React from 'react';
import { chooseIconIndex } from 'utils/helperMethods';
const iconIndex = chooseIconIndex();

const PositiveTriangle = ({ stroke = colorConstants.limeGreen }: { stroke?: string }) => {
    //2K
    if (iconIndex === 1) {
        return (
            <svg width="9" height="8" viewBox="0 0 9 8" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path d="M4.60847 0.5L8.82026 7.25H0.396683L4.60847 0.5Z" fill={stroke} />
            </svg>
        );
    }
    //4K
    if (iconIndex === 2) {
        return (
            <svg width="9" height="8" viewBox="0 0 9 8" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path d="M4.60847 0.5L8.82026 7.25H0.396683L4.60847 0.5Z" fill={stroke} />
            </svg>
        );
    }
    //BELOW 2K
    return (
        <svg width="9" height="8" viewBox="0 0 9 8" fill="none" xmlns="http://www.w3.org/2000/svg">
            <path d="M4.60847 0.5L8.82026 7.25H0.396683L4.60847 0.5Z" fill={stroke} />
        </svg>
    );
};

export default PositiveTriangle;
